import { render, staticRenderFns } from "./NewFeeds.vue?vue&type=template&id=58fa6686"
import script from "./NewFeeds.vue?vue&type=script&lang=js"
export * from "./NewFeeds.vue?vue&type=script&lang=js"
import style0 from "./NewFeeds.vue?vue&type=style&index=0&id=58fa6686&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports